"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var styles_1 = require("@material-ui/core/styles");
var styles = function (theme) {
    return (0, styles_1.makeStyles)({
        topSpacing: {
            paddingTop: theme.spacing(4)
        },
        alignCenter: {
            display: 'flex',
            justifyContent: 'center',
            paddingTop: theme.spacing(3)
        },
        body1High: __assign(__assign({}, theme.typography.body1), { color: theme.palette.text.primary }),
        body2High: __assign(__assign({}, theme.typography.body2), { color: theme.palette.text.primary })
    });
};
exports.styles = styles;
//# sourceMappingURL=styles.js.map